import type { ConsentsControlOptions } from '../../../consents'
import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type { UpBlockHandler } from '../types'
import { newId } from '../utils'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.ConsentsBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.CONSENTS_CONTROL) {
    throw new Error('Expected a valid Consents control')
  }

  const castedOptions = uischema.options as ConsentsControlOptions

  const items = (castedOptions?.configs ?? []).reduce<
    next.ConsentsBlock['settings']['items']
  >((acc, config, index) => {
    acc[newId<next.ConsentItemId>()] = {
      required: Boolean(config.required),
      text: config.textMD,
      topics: config.topics?.map((topic) => upTopic(topic)) ?? [],
      orderIndex: index
    }

    return acc
  }, {})

  return {
    type: next.BLOCK_TYPE.CONSENTS,
    settings: {
      ...upCommonSettings(uischema),
      items
    },
    references: {}
  }
}

const upTopic = (topic: string): next.CONSENT_TOPIC | string => {
  switch (topic) {
    case 'GTC':
      return next.CONSENT_TOPIC.GTC
    case 'DATA_PRIVACY':
      return next.CONSENT_TOPIC.DATA_PRIVACY
    case 'CANCELLATION_POLICY':
      return next.CONSENT_TOPIC.CANCELLATION_POLICY
    case 'EMAIL_MARKETING':
      return next.CONSENT_TOPIC.EMAIL_MARKETING
    case 'SMS_MARKETING':
      return next.CONSENT_TOPIC.SMS_MARKETING
    case 'PHONE_CALL_MARKETING':
      return next.CONSENT_TOPIC.PHONE_CALL_MARKETING
    case 'PRINT_MARKETING':
      return next.CONSENT_TOPIC.PRINT_MARKETING
    default:
      return topic
  }
}
